import React from "react";

import Chips from "../Chips";
import Tooltip from "../Tooltip";

import { getWinClassName } from "@/modules/commonMobile";

import { IStandardBetV4Props } from "@/types/GlobalTypes";

/*
{
	StandardBetV4({
		classes: "sl-green-lighten",

		winCondition: win && (win.dragonValue > win.tigerValue),

		betType: "1:0.95",
		betLabel: "Random",
		betNum: "Random",
		betGroup: "n50",

		betImage: <img src={img_dragon} alt="dragon" />,

		//Optional
		betImages: [
			<img key="dt_0" src={img_dragon} alt="dragon" />,
			<img key="dt_1" src={img_dragon} alt="dragon" />,
			<img key="dt_2" src={img_dragon} alt="dragon" />
		],

		commonProps: this.props
	})
}
*/

export default class StandardBetV4 extends React.Component<IStandardBetV4Props> {
	render() {
		const { commonProps } = this.props;
		const bets = commonProps.bets;
		const betKey = this.props.betNum + "+" + this.props.betGroup,
			win = !!this.props.winCondition;

		return (
			<div key={this.props._key}
				className={"sl-bet " +
					this.props.classes +
					getWinClassName(win)
				}

				{...{
					bet: this.props.betNum,
					group: this.props.betGroup,
					pcode: commonProps.pcode
				}}

				onClick={commonProps.insertBet}>

				<div>
					{this.props.betLabel}
				</div>

				{this.props.betImage}

				<div className="bet-type">
					{this.props.betType}
				</div>

				<Chips
					mobile={commonProps.mobile}
					betOutOfBounds={commonProps.betOutOfBounds}
					chipBase={commonProps.chipBase}
					bets={bets}
					betKey={betKey} />

				<Tooltip bet={bets[betKey]} langStr={commonProps.langdata.language_code} />
			</div>
		);
	}
}